import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { OVERNIGHT } from "@/lib/format";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Experiences } from "@/components/site/Experiences";
import { Gallery, Amenities, Reviews, Promotions, Faq } from "@/components/site/Sections";
import { Location, Footer, WhatsAppFloat } from "@/components/site/Location";
import BookingWizard from "@/components/booking/BookingWizard";

const scrollToBooking = () => setTimeout(() => document.getElementById("reservar")?.scrollIntoView({ behavior: "smooth" }), 30);

export default function Home() {
  const [site, setSite] = useState(null);
  const [preset, setPreset] = useState(null);
  useEffect(() => {
    api.get("/public/site").then((r) => {
      setSite(r.data);
      const c = r.data.settings.content;
      if (c.seo_title) document.title = c.seo_title;
      if (c.seo_description) document.querySelector('meta[name="description"]')?.setAttribute("content", c.seo_description);
    });
  }, []);
  if (!site) return <div className="min-h-screen grid place-items-center font-serif text-2xl text-[#5E6B52]" data-testid="site-loading">Rachel Lodge</div>;
  const { settings, experiences, extras } = site;
  const c = settings.content;
  const search = (p) => { setPreset({ ...p, t: Date.now() }); scrollToBooking(); };
  const pick = (e) => search({ mode: OVERNIGHT.includes(e.slug) ? "noche" : "dia", experience: e.slug });
  return (
    <div className="bg-background" data-testid="home-page">
      <Header title={c.hero_title} />
      <Hero content={c} onSearch={search} />
      <Experiences experiences={experiences} onSelect={pick} />
      <BookingWizard site={site} preset={preset} experiences={experiences} extras={extras} settings={settings} />
      <Promotions promotions={settings.promotions} onBook={scrollToBooking} />
      <Gallery items={c.gallery || []} />
      <Amenities content={c} />
      <Reviews reviews={c.reviews} />
      <Faq faqs={c.faqs} policies={settings.policies} />
      <Location contact={settings.contact} />
      <Footer contact={settings.contact} title={c.hero_title} />
      <WhatsAppFloat phone={settings.contact.whatsapp} />
    </div>
  );
}
